import { render, staticRenderFns } from "./installSoftware.vue?vue&type=template&id=b9cd7e2a&scoped=true&"
import script from "./installSoftware.vue?vue&type=script&lang=js&"
export * from "./installSoftware.vue?vue&type=script&lang=js&"
import style0 from "./installSoftware.vue?vue&type=style&index=0&id=b9cd7e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cd7e2a",
  null
  
)

export default component.exports